import { LEARNING_PHASES } from "../../Learning/constants/learningPhases";
import {
  CLEAR_LEARNING_QUIZ_RESULT,
  SET_LEARNING_ATTEMPTS_USED,
  SET_LEARNING_INVITE_LOCKED,
  INIT_LEARNING_SESSION,
  RESET_LEARNING_GUIDANCE,
  RESET_LEARNING_QUESTIONNAIRE,
  RESET_LEARNING_SESSION,
  SET_LEARNING_BRAND_SUCCESS,
  CLEAR_LEARNING_BRAND,
  SET_LEARNING_DOCUMENT_SCROLL,
  SET_LEARNING_GUIDANCE_INDEX,
  SET_LEARNING_PACKAGE_ERROR,
  SET_LEARNING_PACKAGE_LOADING,
  SET_LEARNING_PACKAGE_SUCCESS,
  SET_LEARNING_RECIPIENT_EMAIL,
  HYDRATE_LEARNING_INVITE_PROGRESS,
  RESTORE_TRAINING_PROGRESS,
  RESET_LEARNING_INVITE_PROGRESS,
  SET_LEARNING_PHASE,
  SET_LEARNING_QUESTION_INDEX,
  SET_LEARNING_QUESTIONNAIRE_ERROR,
  SET_LEARNING_QUESTIONNAIRE_LOADING,
  SET_LEARNING_QUESTIONNAIRE_SUBMITTED,
  SET_LEARNING_QUESTIONNAIRE_SURVEY,
  SET_LEARNING_QUIZ_RESULT,
} from "./constants";

export const initLearningSession = (payload) => ({
  type: INIT_LEARNING_SESSION,
  payload,
});

export const resetLearningSession = () => ({
  type: RESET_LEARNING_SESSION,
});

export const setLearningPackageLoading = (loading) => ({
  type: SET_LEARNING_PACKAGE_LOADING,
  payload: loading,
});

export const setLearningPackageSuccess = (packageData) => ({
  type: SET_LEARNING_PACKAGE_SUCCESS,
  payload: packageData,
});

export const hydrateLearningInviteProgress = (inviteProgress) => ({
  type: HYDRATE_LEARNING_INVITE_PROGRESS,
  payload: inviteProgress,
});

export const restoreTrainingProgress = (progress) => ({
  type: RESTORE_TRAINING_PROGRESS,
  payload: progress,
});

export const resetLearningInviteProgress = () => ({
  type: RESET_LEARNING_INVITE_PROGRESS,
});

export const setLearningRecipientEmail = (email) => ({
  type: SET_LEARNING_RECIPIENT_EMAIL,
  payload: email,
});

export const setLearningPackageError = (error) => ({
  type: SET_LEARNING_PACKAGE_ERROR,
  payload: error,
});

export const setLearningPhase = (phase) => ({
  type: SET_LEARNING_PHASE,
  payload: phase,
});

export const setLearningAttemptsUsed = (attemptsUsed) => ({
  type: SET_LEARNING_ATTEMPTS_USED,
  payload: attemptsUsed,
});

export const setLearningInviteLocked = (isLocked) => ({
  type: SET_LEARNING_INVITE_LOCKED,
  payload: isLocked,
});

/** @deprecated use setLearningAttemptsUsed */
export const setLearningAttemptNumber = (attemptNumber) => ({
  type: SET_LEARNING_ATTEMPTS_USED,
  payload: attemptNumber,
});

export const setLearningQuizResult = (quizResult) => ({
  type: SET_LEARNING_QUIZ_RESULT,
  payload: quizResult,
});

export const clearLearningQuizResult = () => ({
  type: CLEAR_LEARNING_QUIZ_RESULT,
});

export const setLearningGuidanceIndex = (index) => ({
  type: SET_LEARNING_GUIDANCE_INDEX,
  payload: index,
});

export const setLearningDocumentScroll = (payload) => ({
  type: SET_LEARNING_DOCUMENT_SCROLL,
  payload,
});

export const resetLearningGuidance = () => ({
  type: RESET_LEARNING_GUIDANCE,
});

export const setLearningQuestionnaireLoading = (loading) => ({
  type: SET_LEARNING_QUESTIONNAIRE_LOADING,
  payload: loading,
});

export const setLearningQuestionnaireSurvey = (survey) => ({
  type: SET_LEARNING_QUESTIONNAIRE_SURVEY,
  payload: survey,
});

export const setLearningQuestionnaireError = (error) => ({
  type: SET_LEARNING_QUESTIONNAIRE_ERROR,
  payload: error,
});

export const setLearningQuestionIndex = (index) => ({
  type: SET_LEARNING_QUESTION_INDEX,
  payload: index,
});

export const setLearningQuestionnaireSubmitted = (submitted) => ({
  type: SET_LEARNING_QUESTIONNAIRE_SUBMITTED,
  payload: submitted,
});

export const resetLearningQuestionnaire = () => ({
  type: RESET_LEARNING_QUESTIONNAIRE,
});

export const setLearningBrandSuccess = (payload) => ({
  type: SET_LEARNING_BRAND_SUCCESS,
  payload,
});

export const clearLearningBrand = () => ({
  type: CLEAR_LEARNING_BRAND,
});

export const startLearningGuidance = () =>
  setLearningPhase(LEARNING_PHASES.GUIDANCE);

export const startLearningQuestionnaire = () =>
  setLearningPhase(LEARNING_PHASES.QUIZ);

export const reviewLearningGuidance = () =>
  setLearningPhase(LEARNING_PHASES.GUIDANCE);

export const goToLearningIntro = () => setLearningPhase(LEARNING_PHASES.INTRO);
